import CategoriesFilter from 'components/list/Filters/types/CategoriesFilter';
import MultiFieldResource from 'pages/products/resource/fields/MultiFieldResource';
import ProductFilter from 'components/list/Filters/types/ProductFilter';
import ProvidersFilter from 'components/list/Filters/types/ProviderFilter';
import RenderBooleanInputField from 'components/form/InputFields/RenderBooleanInputField';
import RenderTextInputField from 'components/form/InputFields/RenderTextInputField';
import SubcategoriesFilter from 'components/list/Filters/types/SubcategoriesFilter';
import utils from './utils';
import validations from 'helpers/forms/validations';
import category from './category';
import MultiProductIdFilter from 'components/form/filters/MultiProductFilter';

const ProductTitleFilter = ProductFilter;

ProductTitleFilter.defaultProps.source = 'title';
ProductTitleFilter.defaultProps.searchBy = 'title';

export const productAttributeFields = {
    category_id: CategoriesFilter,
    city: RenderTextInputField,
    country: RenderTextInputField,
    enabled: RenderBooleanInputField,
    id: MultiProductIdFilter,
    is_combined: RenderBooleanInputField,
    location_address: RenderTextInputField,
    number_of_persons: RenderTextInputField,
    provider_id: ProvidersFilter,
    street: RenderTextInputField,
    subcategory_id: SubcategoriesFilter,
    title: ProductTitleFilter,
    zipcode: RenderTextInputField,
};

const resourceNames = {
    parkingpro: {
        component: MultiFieldResource,
        fields: {
            parking_id: {
                validate: [
                    validations.guid,
                    validations.required,
                ],
            },
            location_id: {
                validate: [
                    validations.guid,
                    validations.required,
                ],
            },
        },
    },
};

/**
 * Returns fields object for specific resource name.
 *
 * @param {string} resourceName
 * @returns {*} React-component for specific resource name, by default RenderTextInputField.
 */
export const getFieldsByResourceName = (resourceName) => {
    if (!resourceName || !resourceNames[resourceName]) {
        return null;
    }

    return resourceNames[resourceName].fields || null;
};

/**
 * Returns component for specific resource.
 *
 * @param {string} resourceName
 * @returns {*} React-component for specific resource name, by default RenderTextInputField.
 */
export const getComponentByResoureName = (resourceName) => {
    if (!resourceName || !resourceNames[resourceName]) {
        return RenderTextInputField;
    }

    return resourceNames[resourceName].component || RenderTextInputField;

};

/**
 * Parses resource-id string to an object.
 *
 * @param {string} resourceId
 * @returns {Object}
 */
export const parseResourceId = (resourceId) => {
    const parsedResource = {};

    resourceId.split('|').forEach((resource) => {
        parsedResource[resource.split('=')[0]] = resource.split('=')[1];
    });

    return parsedResource;
};

/**
 * Returns resource-id string from resource value object.
 *
 * @param {Object} resourceValues
 * @returns {string}
 */
export const stringifyResourceId = (resourceValues) => {
    const resourceIdValues = [];

    utils.each(resourceValues, (value, key) => {
        resourceIdValues.push(`${ key }=${ value }`);
    });

    return resourceIdValues.join('|');
};

export const invalidProductConfigurations = (configuration) => {
    const requiredConfigurations = [
        'vat_percentage',
    ];

    const invalidConfigurations = {};

    if (utils.isEmpty(configuration)) {
        requiredConfigurations.forEach((key) => {
            invalidConfigurations[key] = null;
        });
    } else {
        requiredConfigurations.forEach((key) => {
            if (utils.isEmpty(configuration[key])) {
                invalidConfigurations[key] = null;
            }
        });
    }

    return invalidConfigurations;
};

export const hasValidProductConfiguration = (configuration) => {
    if (utils.isEmpty(configuration)) {
        return false;
    }

    return utils.isEmpty(invalidProductConfigurations(configuration));
};

export const requiresLicensePlate = (product) => {
    return category.isHub(product.category_id) || category.isParking(product.category_id);
};



// WEBPACK FOOTER //
// ./src/helpers/product.js